import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { TextField, Typography } from '@mui/material';
import type { FormikProps } from 'formik';

import { styles } from './index.styles';

export interface PasswordResetFormValues {
  email: string;
  nonFieldErrors?: string;
}

export interface PasswordResetFormProps
  extends FormikProps<PasswordResetFormValues> {
  className?: string;
}

export const PASSWORD_RESET_EMAIL_FIELD = 'password-reset-email-field';
export const PASSWORD_RESET_BUTTON = 'password-reset-button';

const PasswordResetForm: FC<PasswordResetFormProps> = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
}) => {
  const { t } = useTranslation('login');
  return (
    <form onSubmit={handleSubmit}>
      <TextField
        placeholder={t('email')}
        type="email"
        name="email"
        autoComplete="email"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.email}
        sx={styles.inputField}
        helperText={touched.email && errors.email}
        error={touched.email && !!errors.email}
        required
        data-test-id={PASSWORD_RESET_EMAIL_FIELD}
        fullWidth
      />
      <LoadingButton
        variant="cta"
        fullWidth
        loading={isSubmitting}
        type="submit"
        data-test-id={PASSWORD_RESET_BUTTON}
      >
        {t('resetPassword')}
      </LoadingButton>

      <Typography sx={styles.errorMsg}>{errors.nonFieldErrors}</Typography>
    </form>
  );
};

export default PasswordResetForm;
